import { ChevronRight } from "@assets";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { BodySmall, Title4 } from "@components/Typography";
import { useStyles } from "./styles";
import { ActionItemProps, ActionItemType } from "./types";

export const ActionItem = ({
  title,
  subtitle,
  leftIcon,
  rightIcon = <ChevronRight />,
  onClick,
  type = ActionItemType.Modal,
}: ActionItemProps) => {
  const styles = useStyles();

  const modalStyle = type === ActionItemType.Modal ? styles.modal : undefined;

  return (
    <div style={{ ...styles.container, ...modalStyle }} onClick={onClick}>
      {leftIcon}
      <div style={styles.content}>
        <Title4 style={styles.title}>{title}</Title4>
        {subtitle ? (
          <>
            <Spacing size={SpacingSizes.XXS} />
            <BodySmall style={styles.subtitle}>{subtitle}</BodySmall>
          </>
        ) : null}
      </div>
      {rightIcon}
    </div>
  );
};
